<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-page-frame">
    <iframe title="" :src="url" />
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-page-frame',  

  computed: {
    url() {
      return this.$route.meta ? this.$route.meta.iframeUrl : "#"
    }
  }
});
</script>

<style lang="scss">
.wy-page-frame {
  iframe {
    border: 1px solid #eee;
    width: 100%;
    height: calc(100vh - 120px);
  }
}
</style>